import { Components, Theme } from "@mui/material/styles";
import { getMenuTokens } from "./styles";

export const MuiMenu: Components<Theme>["MuiMenu"] = {
    defaultProps: {
        disablePortal: false,
    },
    styleOverrides: {
        paper: ({ theme }) => getMenuTokens(theme).list,
    },
};
